<template>
    <div>
    </div>
</template>

<script>
import { getUserSupportEncryptionValueAPI } from "@/service/api"
export default {
    name: "free-login",
    data() {
        return {
            userId: this.$route.query.userid,
            token: this.$route.query.token,
            routeName: this.$route.query.routename,
            routeQuery: this.$route.query.routequery,
            origin: this.$route.query.origin, // 来源
            phone: this.$route.query.phone // 手机号
        }
    },
    methods: {
        /**
         * 通过用户类型判断路由
         */
        judgeRouteByType(res) {
            //判断admin_type是否为系统管理员或校管理员或代理商或运营
            if (res.admin_type == 1 || res.admin_type == 2 || res.user_type == 4 || res.user_type == 5 || res.user_type == 6) {
                if (res.user_type == 4 ||res.user_type == 6) {
                    // 代理商跳转至区域数据展板页面
                    if(res.id == 'c2d8dd7094664767a613799874d92620'){
                        this.$router.push({
                        path: "/regiondataboard?agentId=098cac32-922b-49f0-b0cc-d2036bc20475&agentName=和顺县教育局"
                    });
                    }else{
                        this.$router.push({
                        name: "regiondataboard",
                        query: {
                            agentId: this.$store.getters.agentId,
                            agentName: this.$store.getters.agentName
                        }
                    });
                    }

                } else if (res.admin_type == 2) {
                    // 跳转至学校页面
                    this.$router.push({
                        name: this.$store.getters.schoolId == '75047a8a0990480f8abf3a39bc25f1ab' ? 'cloudschooldataboard' : "schooldataboard",
                        params: {
                            schoolId: this.$store.getters.schoolId
                        }, query: {
                            userid:this.userId,
                            tokenId: this.$store.getters.token
                        }
                    });
                } else {
                    //其他
                    this.$router.push({
                        name: 'schoolList'
                    });
                }
            } else {
                this.$Message.error('抱歉，您暂无权限登录该系统！');
            }
        },
        /**
         * @name 获取用户信息
         */
        getUserBaseInfo() {
            let _this = this;
            let userParam = {
                // userId: this.userId
            };
            if(this.token){
                userParam.token = this.token
                this.$store.commit('SET_TOKEN', this.token);
            }else{
                userParam.userId = this.userId
            }
            this.$store.dispatch('getLoginUserInfo', userParam).then(res => {
                //如果用户为代理商则获取代理商id
                if (res.user_type == 4  ) {
                    _this.$store.dispatch('findAgentInfoByUserId', {
                        userId: res.id
                    }).then(() => {
                        _this.judgeRouteByType(res);
                    }).catch(res => {
                    });
                }else{
                    _this.judgeRouteByType(res);
                }
                if (_this.origin != undefined) {
                    this.$store.commit("SET_FREELOGINORIGIN", _this.origin);
                    document.cookie = "freeLoginOrigin=" + _this.origin + ";path=/";
                } else {
                    this.$store.commit("SET_FREELOGINORIGIN", '');
                    document.cookie = "freeLoginOrigin=;path=/";
                }
                if (_this.routeName === '') {
                    _this.judgeRouteByType(res);
                } else {
                    _this.$router.push({
                        name: _this.routeName,
                        params: JSON.parse(_this.routeQuery)
                        // query: {
                        //     origin: this.origin
                        // }
                    });
                }
            }).catch((res) => {
                console.log(res);
            });
        },
        /**
         * @name 根据key获取用户信息
         */
        async getUserSupportEncryptionValue() {
            let params = {
                key:'mobile',
                keyvalue: this.phone
            }
            const res = await getUserSupportEncryptionValueAPI(params);
            if (res.id) {
                this.userId = res.id;
                this.getUserBaseInfo();
            }
        }

    },
    mounted() {
        if (this.phone) {        
            this.getUserSupportEncryptionValue();
        } else {
            this.getUserBaseInfo();
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
